<template>
  <div class="login">
    <div id="inputField">
      <h2>Sign in</h2>
      <hr>
      <div id="fields">
        <p>Email</p>
        <input v-model="email" type="text" placeholder="Email" name="Email">
        <p>Password</p>
        <input v-model="password" type="Password" placeholder="Password" name="Password">
        <button @click="login">
          Sign in
        </button>
      </div>
    </div>
    <!--<input type="submit" value="Submit">-->
    <router-link to="/signup">
      I don't have an account
    </router-link>
  </div>
</template>

<script>
import registration from '@/js/registration.js';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    login() {
      registration.login(this.email, this.password);
    },
  },
};
</script>

<style scoped>
@media screen and (min-width:480px) {
  /*画面サイズが480pxからはここを読み込む*/
  #inputField{
  width: 80%;
  }
  #fields{
  width: 90%;
  }
}
@media screen and (min-width:768px) and ( max-width:1024px) {
  /*画面サイズが768pxから1024pxまではここを読み込む*/
  #inputField{
  width: 50%;
  }
  #fields{
  width: 50%;
  }
}
@media screen and (min-width:1024px) {
/*画面サイズが1024pxからはここを読み込む*/
  #inputField{
  width: 50%;
  }
  #fields{
  width: 50%;
  }
}

.login{
padding: 20px;
text-align: center;
}
#inputField{
    padding: 30px;
    margin: auto;
    border: 1px solid;
}
hr{
    margin-bottom: 30px;
    width: 80%;
}
#fields{
    margin: auto;
}
button{
    padding: 10px;
    margin-bottom: 10px;
    width: 50%;
    border: 1px solid;
    cursor: pointer;
}
#fields input{
    margin-bottom: 30px;
    height: 50px;
    width: 100%;
}
#fields p{
    text-align: left;
    font-size: 0.5em;
}
</style>
